import { render } from "./AsRow.vue?vue&type=template&id=f3e45bfa&ts=true"
import script from "./AsRow.vue?vue&type=script&lang=ts"
export * from "./AsRow.vue?vue&type=script&lang=ts"

import "./AsRow.vue?vue&type=style&index=0&id=f3e45bfa&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/5c6defa0/0/anyclass/anyclass-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__